var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.artists && _vm.artists.length)?_c('div',[_c('BaseSection',{attrs:{"title":"Trending Artists"}},[_c('ArtistBlock',{attrs:{"artists":_vm.artists}})],1)],1):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }